<template>
  <div class="services-section">
    <button @click="navigateToMainPage" class="back-button back-button--img" aria-label="Retour">
      <img src="@/assets/bouton-retour.png" alt="Retour" class="back-button__img" />
      <span class="visually-hidden">Retour</span>
    </button>
    <div class="services-content">
      <h1>Services</h1>
      <p>Découvrez les services proposés pour accompagner les structures, projets et événements esportifs.</p>

      <!-- 1. Accompagnement dans l'esport -->
      <section id="accompagnement-esport" class="service-block">
        <h2>Accompagnement dans l'esport</h2>
        <p>
          Accompagnement complet pour les structures associatives et projets esportifs : diagnostic des besoins, construction
          de la stratégie, mise en place opérationnelle et accompagnement juridique. J'interviens comme un commercial et
          chef de projet orienté esport pour comprendre votre organisation, structurer vos offres et développer des
          partenariats durables.
        </p>
        <h3>Ce que je propose</h3>
        <ul>
          <li>Audit organisationnel et définition des besoins (gouvernance, modèle économique, ressources)</li>
          <li>Mise en place de process opérationnels : organisation d'événements, gestion de membres, logistique</li>
          <li>Accompagnement juridique basique : contrats de bénévolat/partenariat, CGU, RGPD (avec orientation vers un avocat si besoin)</li>
          <li>Construction d'offres commerciales et packages de sponsoring</li>
          <li>Prospection et négociation avec entreprises pour obtenir des sponsors</li>
          <li>Activation des partenariats : visibilité, animation, reporting et suivi des retours</li>
        </ul>
        <h3>Livrables typiques</h3>
        <p>
          Présentation sponsor (deck), conventions/contrats-types, plan d’activation marketing, calendrier opérationnel,
          rapport post-événement et recommandations stratégiques.
        </p>
      </section>

      <!-- 2. Consulting et Développement web (fusion) -->
      <section id="consulting-devweb" class="service-block">
        <h2>Consulting et Développement web</h2>
        <p>
          Conseil stratégique et réalisation technique : je regroupe l'accompagnement métier et le développement web pour
          livrer des solutions complètes, du diagnostic jusqu'à la mise en production.
        </p>

        <h3>Conseil / Consulting</h3>
        <ul>
          <li>Audit technique & fonctionnel</li>
          <li>Conseil en organisation et transformation digitale</li>
          <li>Roadmap produit, priorisation des besoins et accompagnement à la conduite du changement</li>
          <li>Accompagnement au choix d'outils et prestataires</li>
        </ul>

        <h3>Développement web</h3>
        <p>Du site vitrine à l'application métier : conception, développement, déploiement et maintenance.</p>
        <ul>
          <li>Front-end : Vue.js / composants réutilisables, responsive design</li>
          <li>Back-end : API, intégration Node.js / PHP / frameworks selon besoin</li>
          <li>Intégration d'API tierces (paiement, streaming, drive, authentification)</li>
          <li>SEO, performance et bonnes pratiques d'accessibilité</li>
          <li>Tests, CI/CD et déploiement (build, optimisation, hébergement)</li>
          <li>Maintenance évolutive et support</li>
        </ul>

        <h3>Exemples de réalisations</h3>
        <p>
          Sites pour associations, espaces membres sécurisés, outils de gestion d'événements, intégration de flux Twitch/YouTube,
          tableaux de bord et automatisations.
        </p>
      </section>

      <!-- 3. Intervenant -->
      <section id="intervenant" class="service-block">
        <h2>Intervenant</h2>
        <p>
          Interventions en écoles, conférences, ateliers ou formations sur l’esport, le numérique, la gestion de projet, etc.
        </p>
        <ul>
          <li>Conférences sur l’esport et ses enjeux</li>
          <li>Ateliers pratiques sur la gestion de projet agile</li>
          <li>Formations au numérique et l'enjeu de l'IA aujourd'hui</li>
          <li>Animation de tables rondes et débats</li>
        </ul>
        <h3>Quelques thèmes abordés</h3>
        <p>
          - L’esport en France et dans le monde<br>
          - Les métiers du numérique<br>
          - L’innovation dans l’éducation
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesPage',
  methods: {
    navigateToMainPage() {
      this.$router.push({ name: 'MainPage' });
    }
  }
}
</script>

<style scoped>
.services-section {
  background-size: cover;
  background-position: center center;
  background-repeat: repeat;
  background-image: url("../assets/magicpattern-wave-generator.png");
  min-height: 100vh;
  color: #eee;
  font-family: Arial, sans-serif;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 60px;
}

.back-button {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.back-button--img {
  background: #007bff; /* conserve la couleur bleue existante */
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #fff;
  transition: background 0.25s ease, transform 0.08s ease;
}

.back-button--img:hover {
  background-color: #0056b3; /* légère variation à l'hover */
  transform: translateY(-2px);
}

.back-button__img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: inline-block;
}

/* accessibilité : texte caché pour lecteurs d'écran */
.visually-hidden {
  position: absolute !important;
  height: 1px; width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

.services-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 2rem 2rem 2rem;
}

.service-block {
  background: rgba(30,41,59,0.92);
  border-radius: 16px;
  margin: 3rem 0;
  padding: 3rem 2rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.18);
  font-size: 1.15rem;
}

/* Responsive */
@media (max-width: 900px) {
  .services-content {
    padding: 1rem 0.5rem;
  }
  .service-block {
    padding: 1.5rem 1rem;
    margin: 1.5rem 0;
  }
}
</style>